import React from "react";
import { Box } from "@mui/material";
import plusIcon from "@iconify/icons-mdi/plus";
import { InlineIcon } from "@iconify/react";

interface RowType {
  icons?: {
    add?: boolean;
    arrow?: boolean;
    edit?: boolean;
  };
  date?: string | number | Date;
}

interface OcDataTableBodyCellAddIconProps {
  row: RowType;
  handleSelectRow: (params: { action: string; row: RowType }) => void;
  buttonStyle?: React.CSSProperties;
  isNotExaminer?: boolean;
}

export const OcDataTableBodyCellAddIcon: React.FC<
  OcDataTableBodyCellAddIconProps
> = ({ row, handleSelectRow, buttonStyle, isNotExaminer }) => {
  if (row?.icons?.add === false || isNotExaminer) return null;
  let style = { ...buttonStyle };
  if (row?.icons?.arrow || row?.icons?.edit) {
    style = { ...buttonStyle, marginRight: "8px" };
  }
  return (
    <Box
      onClick={() => handleSelectRow({ action: "add", row: row })}
      style={style}
    >
      <InlineIcon
        width="24px"
        height="24px"
        id={`add-${new Date(row?.date || Date.now()).getDate()}`}
        icon={plusIcon}
      />
    </Box>
  );
};

export default OcDataTableBodyCellAddIcon;
